module.exports = __webpack_public_path__ + "img/about-info-img.86662f0b.png";